module.exports = __webpack_public_path__ + "img/phone-call.1deba168.svg";